<template>
    <main>
        <header  v-if="showNav">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <top-nav :open-menu="openMenu" @clicked="openMenu = !openMenu"></top-nav>
            </nav>
        </header>
        <article>
            <slot />
        </article>
    </main>


    <div class="px-2">
        <footer class="p-2 row row-cols-1 row-cols-sm-2 row-cols-md-5 py-5 my-5 border-top bg-dark text-white mb-0">

            <div class="col-6 mb-3">
                <h5>Algemeen</h5>
                <ul class="nav flex-column">
                    <li class="nav-item mb-2"><a href="/abonnementen" class="nav-link p-0 text-muted">Abonnementen</a></li>
<!--                    <li class="nav-item mb-2"><a href="/over-ons" class="nav-link p-0 text-muted">Onze visie</a></li>-->
                    <li class="nav-item mb-2"><a href="/huisregels" class="nav-link p-0 text-muted">Huisregels</a></li>
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Videos</a></li>-->
                    <li class="nav-item mb-2"><a href="/faq" class="nav-link p-0 text-muted">FAQ</a></li>
                    <li class="nav-item mb-2"><a href="/reviews" class="nav-link p-0 text-muted">Reviews</a></li>
                    <li class="nav-item mb-2"><a href="/franchise" class="nav-link p-0 text-muted">Franchise</a></li>
                </ul>
            </div>

            <div class="col-6 mb-3">
                <h5>Services</h5>
                <ul class="nav flex-column">
                    <li class="nav-item mb-2"><a href="/kracht-conditie-training" class="nav-link p-0 text-muted">Vrije training</a></li>
                    <li class="nav-item mb-2"><a href="/personal-training" class="nav-link p-0 text-muted">Personal training</a></li>
                    <li class="nav-item mb-2"><a href="/coaches" class="nav-link p-0 text-muted">Onze Coaches</a></li>
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Lifestyle coaching</a></li>-->
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Buddy training</a></li>-->
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>-->
                </ul>
            </div>


<!--            <div class="col-6 mb-3">-->
<!--                <h5>Bedrijven</h5>-->
<!--                <ul class="nav flex-column">-->
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Abonnementen</a></li>-->
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Services</a></li>-->
<!--                    <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQ</a></li>-->
<!--                </ul>-->
<!--            </div>-->


            <div class="col-6 col-mb-3">
                <h5>Legal</h5>
                <ul class="nav flex-column">
                    <li class="nav-item mb-2"><a href="/legal/algemene-voorwaarden" class="nav-link p-0 text-muted">Voorwaarden</a></li>
                    <li class="nav-item mb-2"><a href="/legal/privacy-policy" class="nav-link p-0 text-muted">Privacy policy</a></li>
                </ul>
            </div>


            <div class="col-6 col-mb-3"></div>


            <div class="col-6 col-mb-3 d-none d-md-block">
                <h5>Adres</h5>
                <div class="mb-2">
                    Smedenstraat 286<br/>
                    7411RD, Deventer<br/>
                    +31 6 49 67 28 71<br/>
                    <span class="text-muted">Bezoek op afspraak</span>
                </div>
            </div>

            <div class="col-md-12 d-none d-md-block"></div>
            <div class="col-6 col-md-3 col-lg-2 mt-4">
                <a href="/" class="d-flex align-items-center mb-3 link-light text-decoration-none">
                    <img src="/images/pg-logo-wide-white.png" alt="" style="width:100%;">
                </a>
                <div class="mb-2 d-md-none">
                    Smedenstraat 286<br/>
                    7411RD, Deventer<br/>
                    +31 6 49 67 28 71<br/>
                </div>

                <p class="text-muted m-0">
                    © 2021-{{currentYear}}<br/>
                    Private Gym™ B.V.
                </p>
            </div>

        </footer>

    </div>

</template>

<script>
import { Link } from '@inertiajs/vue3'
import RondleidingButton from "./Index/RondleidingButton";
import ActionButtons from "./Index/ActionButtons";
import TopNav from "./Nav/TopNav";

export default {
    components: {
        TopNav,
        ActionButtons,
        RondleidingButton,
        Link,
    },

    props: {
        footer: {default: true},
        showNav: {default: true},
    },

    data() {
      return {
          openMenu: false,
      }
    },

    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>
